import React, { useCallback, memo } from 'react';
import "./workforcesuggestioncomponent.css";
import UserListComponent from './listofusers/UserListComponent';

const WorkforceSuggestionComponent = ({
  handleSelectedUserData,
  workforceEntityRecommenderPayloadData,
  filterRequired,
  showSelectAll,
  showDistanceSlider,
  isMultiSelect,
  showDetails,
}) => {
  const onDataChangeCallback = useCallback(
    (selectedUsers, selectedGroup, selectAll, selectedFilters, distanceValue) => {
      handleSelectedUserData({
        selectedUsers,
        selectedGroup,
        selectAll,
        selectedFilters,
        distanceValue
      });
    },
    [handleSelectedUserData]
  );

  return (
    <>
      <div className="broadcast-wrapper">
        <UserListComponent
          onDataChange={onDataChangeCallback}
          payloadDataForWorkforceEntityRecommender={workforceEntityRecommenderPayloadData}
          filterRequired={filterRequired}
          showSelectAll={showSelectAll}
          showDistanceSlider={showDistanceSlider}
          isMultiSelect={isMultiSelect}
          showDetails={showDetails}
        />
      </div>
    </>
  );
};

export default memo(WorkforceSuggestionComponent);